// DSR Invite User management
// // Get
export const GET_DSR_INVITE_LINK_REQUEST = 'get_dsr_invite_link_request';
export const GET_DSR_INVITE_LINK_SUCCESS = 'get_dsr_invite_link_success';
export const GET_DSR_INVITE_LINK_FAILURE = 'get_dsr_invite_link_failure';
export const GET_DSR_INVITE_LINK_RESET = 'get_dsr_invite_link_reset';